import { useOverlayItem } from '@flipster/overlay';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { stack } from '@flipster/styled-system/patterns';

import TopNBids from '../_bid/TopNBids';
import WinnerAnnouncement from '../_bid/WinnerAnnouncement';
import { AuctionDetails, AuctionTitle } from '../_misc/auction';

const PastAuctionModal = () => {
  const { onClose } = useOverlayItem();
  return (
    <Modal size='large' scrollable>
      <Modal.Close onClose={onClose} />
      <Modal.Header>
        <Modal.Title label={<AuctionTitle />} />
      </Modal.Header>
      <Modal.Content
        css={stack.raw({ pb: 60, gap: 40, textStyle: 'Text/M/Regular', color: 'content.default.level-4' })}
      >
        <WinnerAnnouncement />
        <AuctionDetails />
        <TopNBids />
      </Modal.Content>
    </Modal>
  );
};

export default PastAuctionModal;
